import "./styles.css";
import type { ComponentType } from "react";

export interface SidePopupDetails {
    title: string;
    Content: ComponentType<{ onClose: () => void; details?: any }>;
    contentDetails?: any;
}

interface Props {
    onClose: () => void;
    details?: SidePopupDetails;
}

export default function SidePopup({ onClose, details }: Props) {
    if (!details) return null;
    const { title, Content, contentDetails } = details;

    return (
        <div className="side-popup">
            <div className="side-popup-header">
                <h2 className="side-popup-title">{title}</h2>
                <button type="button" className="side-popup-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
            </div>
            <div className="side-popup-body">
                <Content onClose={onClose} details={contentDetails} />
            </div>
        </div>
    );
}
